import React from 'react';
import styles from './SbSharedPagination.scss';

const SbSharedPaginationSeparator = () => {
    return (
        <li className={`${styles.paginationItem} ${styles.separatorItem}`}>
            <span className={styles.separator}>...</span>
        </li>
    );
};

export { SbSharedPaginationSeparator };
